import { Component, Input } from '@angular/core';
import { encapsulation } from '../../encapsulation';

@Component({
    selector: 'ubx-field-label',
    templateUrl: './field-label.component.html',
    host: { class: 'ubx-field-label flx' },
    encapsulation
})
export class UBXFieldLabelComponent {
    @Input() required: boolean;
}
